<template>
  <el-row :gutter="10" style="padding: 8px;">
    <el-col
        :span="8"
        class="record-box"
    >
      <el-text >{{i18n.tkey('lang_product_information')}}</el-text>

    </el-col>
    <el-col
        :span="8"
        class="record-box"
    >

      <el-text >{{i18n.tkey('lang_merchant_info')}}</el-text>

    </el-col>
    <el-col
        :span="2"
        class="record-box"
    >

      <el-text >{{i18n.tkey('lang_state')}}</el-text>

    </el-col>
    <el-col
        :span="6"
        class="record-box"
    >

      <el-text >{{i18n.tkey('lang_operate')}}</el-text>
    </el-col>
  </el-row>
<hr>
  <div v-for="(value, index) in dataList" :key="value.id">
     <el-row :gutter="10" style="padding: 8px;">
      <el-col
          :span="8"
          class="record-box"
      >
        <div style="display: flex">
          <img width="60px" height="60px" :src="myUtil.generateProductImg(value, imgRandomNum)" style="width: 60px; height: 60px;display: inline-block;vertical-align:baseline">
          <div style="padding-left: 10px;">

            <el-text >{{value.productid}}:</el-text>
            <el-text >{{value.productname}}</el-text>
            <br>
            <el-text >{{value.description}}</el-text>
            <br>
            <el-text >${{value.cost}}</el-text>
          </div>
        </div>
      </el-col>
      <el-col
          :span="8"
          class="record-box"
      >
        <div style="display: flex">
          <div style="padding-left: 10px;">

            <el-text >{{value.member.id}}:</el-text>
            <br>
            <el-text >{{value.member.name}}</el-text>
            <br>
            <el-text >{{value.member.telephone}}</el-text>
          </div>
        </div>

      </el-col>
      <el-col
          :span="2"
          class="record-box"
      >

        <el-text >{{getDataState(value.updateId)}}</el-text>

      </el-col>
      <el-col
          :span="6"
          class="record-box"
      >
        <div>

          <el-text type="primary" @click="clickCancel(index)" v-if="value.updateId=='-1'" tkey="取消代理">{{i18n.tkey("lang_cancel_agent")}}</el-text>
          &nbsp;&nbsp;
          <!--                      <el-text type="primary" @click="clickOpenPersonalChat(scope.row.member.login)" v-if="scope.row.updateId=='3'" tkey="打開聊天">{{i18n.tkey("lang_start_chat")}}</el-text>-->
          <!--                      &nbsp;&nbsp;-->
          <el-text type="danger" @click="clickCancelDelBtn(index)" v-if="value.updateId=='2'" tkey="刪除">{{i18n.tkey("lang_delete")}}</el-text>
          &nbsp;&nbsp;
          <el-text type="danger" @click="clickDelBtn(index)" v-if="value.updateId=='0'" tkey="取消代理">{{i18n.tkey("lang_cancel_agent")}}</el-text>

        </div>
      </el-col>
    </el-row>
    <hr>
        <div v-for="(value2, index2) in value.materials" :key="value2.id" style="background-color: #f5f5f5;">
        <div v-show="value2.verify !== 1">
          <el-row :gutter="10" style="padding: 8px;">
            <el-col
                :span="18"
                class="record-box"
            >
              <div style="display: flex">
                <img width="60px" height="60px" :src="myUtil.generateProductImg(value2, imgRandomNum)" style="width: 60px; height: 60px;display: inline-block;vertical-align:baseline">
                <div style="padding-left: 10px;">

                  <el-text >{{value2.productname}}</el-text>

                  <el-text >{{value2.producttype}}</el-text>
                  <br>
                  <el-text >${{i18n.tkey('lang_commission')}}:${{value2.pocost}}</el-text>
                </div>
              </div>
            </el-col>
            <el-col
                :span="6"
                class="record-box"
            >
              <div>

                <el-button type="primary" @click="clickOpenShare(value2)" v-if="value.updateId=='-1'" tkey="分享">

                  <font-awesome-icon icon="fa-solid fa-share-nodes" /></el-button>
                <el-button type="danger" @click="clickDelAgent(value2.id)" tkey="刪除"><font-awesome-icon icon="fa-solid fa-trash" /></el-button>

              </div>
            </el-col>
          </el-row>
          <hr>
        </div>
        </div>
  </div>
    <div v-loading="loading">

        <PaginationComponent :pageObj="pageObj" @goPage="clickGoPage" />
    </div>
</template>

<script setup>

import {inject, ref} from "vue";
import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
import myUtil from "@/util/util";
import record3Api from "@/request/record3Api";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTrash, faShareNodes } from '@fortawesome/free-solid-svg-icons'
import {library} from "@fortawesome/fontawesome-svg-core";
import materialApi from "@/request/materialApi";

const props = defineProps(["dataList", "pageObj"])
const emits = defineEmits(["goPage", "save-complete","goShare"])

const imgRandomNum = Math.random()
const i18n = inject("i18n")
// const userInfoRef = toRef(useUserinfo())

const loading = ref(false)


library.add(faTrash,faShareNodes)

function clickGoPage(value){
    emits("goPage", value)
}

function getDataState(updateId){
  if (updateId === 0){
    return  i18n.tkey("lang_applying")
  }else if (updateId === -1){
    return i18n.tkey("lang_passed")
  }else if (updateId === 1){
    return i18n.tkey("lang_take_down")
  }else{
    return i18n.tkey("lang_cancel_agent")
  }
}

function clickCancel(index){
  myUtil.confirmWarning(i18n.tkey("lang_cancel_agent_warning"), () => {

    loading.value = true
    const obj = props.dataList[index]
    const request = record3Api.cancelAgentRecord3
    const params = request.getParams()
    params.id = obj.record3Id

    request.send(params, (res) => {
        loading.value = false
        if (res.code == 200){

            myUtil.alertSuccess(i18n.tkey("lang_cancel_agent_success"))

          // eslint-disable-next-line no-undef
          if (props.dataList.length == 1 && props.pageObj.pageNum > 1){
            // eslint-disable-next-line vue/no-mutating-props
               props.pageObj.pageNum--
          }
          clickGoPage(props.pageObj.pageNum)


        }else{
            myUtil.alertError(res.lang_request_error)
        }
    })
  })

}

function clickOpenShare(vaule){
  emits("goShare", vaule)
}

//刪除代理商品
function clickDelAgent(id) {

  myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
    loading.value = true
    const request = materialApi.takeDownAgentMaterial
    const params = request.getParams()
    params.id = id

    request.send(params, (res) => {
      loading.value = false
      if (res.code == 200){

        myUtil.alertSuccess(i18n.tkey("lang_delete_success"))

        if (props.dataList.length == 1 && props.pageObj.pageNum > 1){
          props.pageObj.pageNum--
        }
        clickGoPage(props.pageObj.pageNum)


      }else{
        myUtil.alertError(res.lang_request_error)
      }
    })

  })

}

function clickDelBtn(index){
    myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
      loading.value = true
      const obj = props.dataList[index]
      const request = record3Api.delAgentRecord3
      const params = request.getParams()
      params.id = obj.record3Id
      if (obj.updateId == 0){
        request.send(params, (res) => {
          loading.value = false
          if (res.code == 200){

            // $.sendSysMessage($.cookie("name")+",取消或刪除了對您的 "+obj.productname+" 產品的代理申請",[],[obj.member.login])
            myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
            // eslint-disable-next-line no-undef
            if (props.dataList.length == 1 && props.pageObj.pageNum > 1){
              // eslint-disable-next-line vue/no-mutating-props
              props.pageObj.pageNum--
            }
            clickGoPage(props.pageObj.pageNum)
          }else{
            myUtil.alertError(res.lang_request_error)
          }
        })
      }
    })

}

function clickCancelDelBtn(index){
  myUtil.confirmWarning(i18n.tkey("lang_agent_delete_warning"), () => {
    loading.value = true
    const obj = props.dataList[index]
    const request = record3Api.deleteAgentRecord3AndProduct
    const params = request.getParams()
    params.id = obj.record3Id
    if (obj.updateId == 2 || obj.updateId == 1){

      request.send(params, (res) => {
        loading.value = false
        if (res.code == 200){
          // $.sendSysMessage($.cookie("name")+",取消或刪除了對您的 "+obj.productname+" 產品的代理申請",[],[obj.member.login])
          myUtil.alertSuccess(i18n.tkey("lang_delete_success"))

          // eslint-disable-next-line no-undef
          if (props.dataList.length == 1 && props.pageObj.pageNum > 1){
            // eslint-disable-next-line vue/no-mutating-props
            props.pageObj.pageNum--
          }
          clickGoPage(props.pageObj.pageNum)
        }else{
          myUtil.alertError(res.lang_request_error)
        }
      })

    }
  })
}


</script>

<style scoped>

</style>